import { useMutation } from '@tanstack/react-query';
import { useSharedMediaApi } from 'services';

export const useDeleteTemporaryMediaItem = () => {
  const { deleteTemporaryMediaItem } = useSharedMediaApi();

  return useMutation({ mutationFn: deleteTemporaryMediaItem });
};
